export default "__VITE_ASSET__f68cb3b7__"